<template>
  <v-radio-group v-model="selected" hide-details @change="change">
    <div v-if="isRound === false">
      <RadioBox
        v-for="(targetOption, i) in targetOptions"
        :selected-value="selected"
        :value="targetOption.value"
        :up="i === 0"
        :down="i === targetOptions.length - 1"
        :title="targetOption.title"
        :description="targetOption.description"
      />
    </div>
    <div v-else>
      <RadioBox
        v-for="(targetOption, i) in targetRoundOptions"
        :selected-value="selected"
        :value="targetOption.value"
        :up="i === 0"
        :down="i === targetRoundOptions.length - 1"
        :title="targetOption.title"
        :description="targetOption.description"
      />
    </div>
  </v-radio-group>
</template>

<script>
import RadioBox from './radioBox.vue'

export default {
  components: { RadioBox },
  props: {
    selected: String,
    isRound: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    targetOptions: [
      {
        value: 'INSTITUTION',
        title: 'Institucional',
        description:
          'Todos los alumnos pueden salir solos en las fechas establecidas',
      },
      {
        value: 'LEVELS',
        title: 'Niveles curriculares',
        description:
          'Los alumnos de los niveles seleccionados pueden salir solos en las fechas establecidas',
      },
      {
        value: 'EXTRA_LEVELS',
        title: 'Niveles extracurriculares',
        description:
          'Los alumnos de los niveles seleccionados pueden salir solos en las fechas establecidas',
      },
      {
        value: 'GROUPS',
        title: 'Grupos',
        description:
          'Los alumnos de los grupos seleccionados pueden salir solos en las fechas establecidas',
      },
      {
        value: 'SUBGROUPS',
        title: 'Subgrupos',
        description:
          'Los alumnos de los subgrupos seleccionados pueden salir solos en las fechas establecidas',
      },
      {
        value: 'STUDENTS',
        title: 'Alumnos',
        description:
          'Los alumos seleccionados pueden salir solos en las fechas establecidas',
      },
    ],
    targetRoundOptions: [
      {
        value: 'INSTITUTION',
        title: 'Institucional',
        description: 'Todos los alumnos pueden ser solicitados por la ronda',
      },
      {
        value: 'LEVELS',
        title: 'Niveles curriculares',
        description:
          'Los alumnos de los niveles seleccionados pueden ser solicitados por la ronda',
      },
      {
        value: 'EXTRA_LEVELS',
        title: 'Niveles extracurriculares',
        description:
          'Los alumnos de los niveles seleccionados pueden ser solicitados por la ronda',
      },
      {
        value: 'GROUPS',
        title: 'Grupos',
        description:
          'Los alumnos de los grupos seleccionados pueden ser solicitados por la ronda',
      },
      {
        value: 'SUBGROUPS',
        title: 'Subgrupos',
        description:
          'Los alumnos de los subgrupos seleccionados pueden ser solicitados por la ronda',
      },
      {
        value: 'STUDENTS',
        title: 'Alumnos',
        description:
          'Los alumos seleccionados pueden ser solicitados por la ronda',
      },
    ],
  }),
  methods: {
    change() {
      this.$emit('selected', this.selected)
    },
  },
}
</script>

<style scoped>
.radio-border {
  border: 1px solid;
  border-color: #ccc;
  margin-bottom: 0 !important;
  padding: 1.5rem;
}
.radio-up {
  border-radius: 0.5rem 0.5rem 0px 0px;
}
.radio-down {
  border-radius: 0px 0px 0.5rem 0.5rem;
}
.radio-selected {
  background-color: #faeced;
  border-color: #f44336;
}
</style>
